import { render } from "./searchBuildSite.vue?vue&type=template&id=00606b35"
import script from "./searchBuildSite.vue?vue&type=script&lang=js"
export * from "./searchBuildSite.vue?vue&type=script&lang=js"

import "./searchBuildSite.vue?vue&type=style&index=0&id=00606b35&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__